export default __webpack_public_path__ + "static/media/elo-bgblack.55f9dfe9.svg";